import { useGetSiteQuery } from "features/site/siteApi";

export const useSite = () => {
  const { data } = useGetSiteQuery();
  const logo = data ? data.logo : "";
  const siteMainEmail = data ? data.siteMainEmail : "";
  const favicon = data ? data.favicon : "";

  const frontWalletAuthPageColor = data
    ? data.frontWalletAuthPageColor
    : "#111111";
  const registrationType = data ? data.registrationType : "extended";

  const frontWalletSecondaryLogo = data
    ? data.frontWalletSecondaryLogo
    : "logo_dark.svg";

  const privacyAndPolicyUrl = data
    ? data.privacyAndPolicyUrl
    : "/privacy-and-policy";

  const termsAndConditionsUrl = data
    ? data.termsAndConditionsUrl
    : "/terms-and-conditions";

  const btcManualSellAddress = data ? data.btcManualSellAddress : "";
  const ethErc20ManualSellAddress = data ? data.ethErc20ManualSellAddress : "";
  const trxTrc20ManualSellAddress = data ? data.trxTrc20ManualSellAddress : "";
  return {
    logo,
    siteMainEmail,
    privacyAndPolicyUrl,
    termsAndConditionsUrl,
    frontWalletAuthPageColor,
    frontWalletSecondaryLogo,
    registrationType,
    favicon,
    btcManualSellAddress,
    ethErc20ManualSellAddress,
    trxTrc20ManualSellAddress,
  };
};
